// Logs.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

export function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/admin/logs')
      .then(r => setLogs(r.data))
      .finally(() => setLoading(false));
  }, []);

  const fmt = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString();
  };

  return (
    <div className="admin-card">
      <h2>Submission Logs</h2>
      <p style={{ fontSize: 14, color: 'var(--text-light)', marginBottom: 16 }}>
        Logs auto-delete after 6 months. Showing most recent 500 submissions.
      </p>
      {loading ? <p>Loading...</p> : (
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Driver Name</th>
                <th>Company</th>
                <th>Status</th>
                <th>Driver Copy</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr><td colSpan={5} style={{ color: 'var(--text-light)', textAlign: 'center' }}>No submissions yet</td></tr>
              ) : logs.map(l => (
                <tr key={l.id}>
                  <td style={{ whiteSpace: 'nowrap' }}>{fmt(l.submitted_at)}</td>
                  <td>{l.driver_name}</td>
                  <td>{l.company_name}</td>
                  <td>
                    <span className={`badge ${l.status === 'success' ? 'badge-success' : 'badge-error'}`}>
                      {l.status}
                    </span>
                  </td>
                  <td>
                    {l.driver_email_sent === true ? (
                      <span className="badge badge-success">sent</span>
                    ) : l.driver_email_sent === false ? (
                      <span className="badge badge-error" title={l.driver_email_error || 'Failed'}>
                        failed
                      </span>
                    ) : (
                      <span style={{ color: 'var(--text-light)' }} title="No email provided, or MCS email failed">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Logs;
